import type { XhrStatus } from 'redux/reusable/xhrStatus';
import { createXhrStatusModule } from 'redux/reusable/xhrStatus';
import type { Suggestion } from 'types/suggestion';
import type { LightUser, User } from 'types/user';
import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory('timely/suggestions');
export const { wrapFetching, wrapSaving, withXhrStatusReducer } =
  createXhrStatusModule('suggestions');

export const fetchedSuggestions = actionCreator<Array<Suggestion<User>>>('FETCHED_SUGGESTIONS');
export const dismissSuggestionId = actionCreator<number>('DISMISS_SUGGESTION_ID');
export const reAppendSuggestion = actionCreator<Suggestion<number>>('RE_APPEND_SUGGESTION');
// NB: Backend suggestion acceptance is done via hour.suggestion_id, so this method is only used to update local state.
export const acceptSuggestionId = actionCreator<number>('ACCEPT_SUGGESTION_ID');
export const appendSuggestion = actionCreator<Array<Suggestion<User>>>('INJECT_SUGGESTIONS');
export const setSuggestionEntries = actionCreator<{
  suggestionId: number;
  entryIds: Array<number>;
}>('SET_SUGGESTION_ENTRIES');

export type Suggester = Pick<LightUser, 'id' | 'email' | 'name' | 'avatar' | 'updated_at'>;

type Suggestions = Record<number, Suggestion>;
export type Suggesters = Record<number, Suggester>;

export interface NormalizedPayload {
  entities: {
    suggestions: Suggestions;
    suggesters: Suggesters;
  };
  result: Array<number>;
}
export interface State {
  xhrStatus: XhrStatus;
  entities: {
    suggestions: Suggestions;
    suggesters: Suggesters;
  };
  result: Array<number>;
}
